import { Rule } from 'antd/es/form';

const BRACES_REGEX = /{+\s*([^{}]*?)\s*}+/g;

/** Returns list of "raw" invalid placeholder occurrences (wrong name and/or wrong braces format) found in the text */
export function findInvalidPlaceholders(text: string | undefined, allowedPlaceholders: readonly string[]): string[] {
  if (!text) {
    return [];
  }

  const invalid: string[] = [];
  let match = BRACES_REGEX.exec(text);

  while (match) {
    const [full, inner] = match;
    const isDoubleBraces = /^{{[^{}]*}}$/.test(full);
    const isAllowedName = allowedPlaceholders.includes(inner);

    if (!isDoubleBraces || !isAllowedName) {
      invalid.push(full);
    }

    match = BRACES_REGEX.exec(text);
  }

  return invalid;
}

export function getPlaceholdersHint(allowedPlaceholders: readonly string[]): string {
  return `Available placeholders: ${allowedPlaceholders.map((placeholder) => `{{${placeholder}}}`).join(', ')}`;
}

export function createPlaceholdersValidatorRule(allowedPlaceholders: readonly string[]): Rule {
  const allowedPlaceholdersText = allowedPlaceholders.map((placeholder) => `{{${placeholder}}}`).join(', ');

  return {
    validator: (_, value?: string) => {
      const invalid = findInvalidPlaceholders(value, allowedPlaceholders);

      if (invalid.length > 0) {
        return Promise.reject(new Error(`Available only ${allowedPlaceholdersText}. Found invalid: ${invalid.join(', ')}`));
      }

      return Promise.resolve();
    },
  };
}
